import { action, Action, thunk, Thunk } from 'easy-peasy';

import { connectivityService } from '~/data/connectivity/ConnectivityService';
import { OfflineStatus } from '~/data/connectivity/types';
import { localStorageGet, localStorageSet } from '~/app/helpers/localStorage';

const initial = connectivityService.getSnapshot();

export interface OfflineModel {
  status: OfflineStatus;
  networkStatus: OfflineStatus;
  time: string | null;
  doNotShowDialogAgain: boolean;
  _updateState: Action<OfflineModel>;
  setStatus: Thunk<OfflineModel, OfflineModel['status']>;
  setNetworkStatus: Thunk<OfflineModel, OfflineModel['networkStatus']>;
  setDoNotShowDialogAgain: Action<OfflineModel, OfflineModel['doNotShowDialogAgain']>;
  isSyncingOfflineData: boolean;
  setSyncingOfflineData: Action<OfflineModel, boolean>;
}

export const offlineModel: OfflineModel = {
  status: initial.status,
  networkStatus: initial.networkStatus,
  time: initial.time,
  doNotShowDialogAgain: localStorageGet('offline-do-not-show-again') === 'yes',
  _updateState: action((state) => {
    const snap = connectivityService.getSnapshot();
    state.status = snap.status;
    state.networkStatus = snap.networkStatus;
    state.time = snap.time;
  }),
  setStatus: thunk((_actions, payload) => {
    connectivityService.setManualStatus(payload);
  }),
  setNetworkStatus: thunk((_actions, payload) => {
    connectivityService.setNetworkStatus(payload);
  }),
  setDoNotShowDialogAgain: action((state, payload) => {
    state.doNotShowDialogAgain = payload;
    localStorageSet('offline-do-not-show-again', payload ? 'yes' : 'no');
  }),
  isSyncingOfflineData: false,
  setSyncingOfflineData: action((state, payload) => {
    state.isSyncingOfflineData = payload;
  }),
};
